export const isAnchorTagAtBeginning = (content) => {
  return content.indexOf('<a') === 0;
};

export const ordinalOfAnchorStartTag = (content) => {
  return content.indexOf('<a');
};

export const ordinalOfAnchorEndTag = (content) => {
  return content.indexOf('</a>');
};
